const get = require('lodash.get');
const { show, hide, disableValidations, enableValidations } = require('../base');
const constants = require('../../../constants');

module.exports = {
    handleChangeOnBusinessType(ev, element, ctx, ...elementNames) {
        const fieldName = get(element, 'attributes.name');
        const bizType = get(ctx, `data.fields['${fieldName}'].value`);
        const countryCode = get(ctx, 'content.countryCode');

        if (bizType) {
            elementNames.forEach((elementName) => {
                ctx.dataActions.updateField(elementName, '');

                if (elementName === 'businessRegistrationNumber' && countryCode === constants.RU) {
                    return;
                }

                show(elementName, ctx);
            });
        } else {
            elementNames.forEach((elementName) => {
                hide(elementName, ctx);
            });
            return;
        }


        if (constants.NON_ENTITY_BUSINESS_TYPES.includes(bizType)) {
            hide('businessIncorporationQuestion', ctx);
            hide('businessCountryOfIncorporation', ctx);
            disableValidations('businessCountryOfIncorporation', ctx);
            hide('businessEstablishedDate', ctx);
            disableValidations('businessEstablishedDate', ctx);
            hide('businessRegistrationNumberQuestion', ctx);
            hide('businessRegistrationNumber', ctx);
        } else {
            enableValidations('businessEstablishedDate', ctx);
            ctx.dataActions.updateField('businessCountryOfIncorporation', countryCode);
            enableValidations('businessCountryOfIncorporation', ctx);
        }
    },
    handleChangeOnCountryOfIncorporation(event, element, context) {
        const userCountryCode = get(context, 'content.countryCode');

        if ((!userCountryCode && !event) || event !== userCountryCode) {
            hide('businessRegistrationNumberQuestion', context);
            hide('businessRegistrationNumber', context);
            context.dataActions.updateField('businessRegistrationNumber', '');
        } else {
            show('businessRegistrationNumberQuestion', context);
            show('businessRegistrationNumber', context);
        }
    }
};
